export const faqData: { [category: string]: { id: number; question: string; answer: string }[] } = {
    Abertura: [
        { 
            id: 1, 
            question: "Quanto tempo leva para abrir uma empresa?", 
            answer: "O tempo de desenvolvimento varia conforme a complexidade do projeto. Softwares mais simples podem levar algumas semanas, enquanto sistemas mais robustos podem levar meses. Trabalhamos com metodologias ágeis para garantir entregas rápidas e eficientes." 
        },
        { 
            id: 2, 
            question: "Qual custo para manter uma empresa?", 
            answer: "Sim! Criamos tanto aplicativos mobile (Android e iOS) quanto sistemas web personalizados, garantindo que sua solução seja acessível em qualquer dispositivo." 
        },
        { 
            id: 3, 
            question: "Posso acompanhar o progresso do meu software durante o desenvolvimento?", 
            answer: "Sim! Nossa equipe mantém uma comunicação constante e fornecemos atualizações frequentes para que você possa acompanhar o progresso e validar as entregas." 
        },
    ],
    Impostos: [
        { 
            id: 4, 
            question: "Vocês oferecem suporte à infraestrutura e servidores?", 
            answer: "Sim! Cuidamos da configuração, manutenção e otimização de servidores, garantindo alta disponibilidade, segurança e escalabilidade para o seu sistema." 
        },
        { 
            id: 5, 
            question: "Trabalham com soluções em nuvem?", 
            answer: "Sim! Utilizamos serviços de nuvem como AWS, Google Cloud e Azure para garantir flexibilidade, desempenho e segurança para os seus sistemas." 
        },
        { 
            id: 6, 
            question: "Meu sistema poderá escalar caso minha empresa cresça?", 
            answer: "Sim! Nossos projetos são desenvolvidos com escalabilidade em mente, permitindo que seu sistema acompanhe o crescimento do seu negócio sem perda de desempenho." 
        },
    ],
    Sistema: [
        { 
            id: 7, 
            question: "Como a Inteligência Artificial pode ajudar o meu negócio?", 
            answer: "A IA pode automatizar processos, melhorar o atendimento ao cliente, aumentar a eficiência operacional e até gerar insights estratégicos com base em dados." 
        },
        { 
            id: 8, 
            question: "Vocês desenvolvem chatbots para atendimento automatizado?", 
            answer: "Sim! Criamos chatbots inteligentes que podem responder dúvidas, captar leads e até fechar vendas, operando 24h por dia no WhatsApp e outras plataformas." 
        },
        { 
            id: 9, 
            question: "É possível personalizar uma IA para minha empresa?", 
            answer: "Sim! Treinamos modelos de IA específicos para seu negócio, garantindo que a solução atenda exatamente às suas necessidades." 
        },
    ],
    MEI: [
        { 
            id: 10, 
            question: "O que é Squad as a Service?", 
            answer: "É a terceirização de times completos de tecnologia para atuar diretamente no seu projeto, sem necessidade de contratação interna." 
        },
        { 
            id: 11, 
            question: "Quais profissionais fazem parte do squad?", 
            answer: "Os squads podem incluir desenvolvedores, designers, product owners, QA testers e outros especialistas conforme sua necessidade." 
        },
        { 
            id: 12, 
            question: "Por que contratar um squad dedicado?", 
            answer: "Ter um time dedicado garante agilidade, especialização e eficiência no desenvolvimento do seu software, sem a burocracia de contratação interna." 
        },
    ],
    Perícias: [
        { 
            id: 13, 
            question: "Vocês ajudam na concepção do produto?", 
            answer: "Sim! Ajudamos a definir requisitos, validar ideias e criar um roadmap estratégico para garantir o sucesso do seu produto." 
        },
        { 
            id: 14, 
            question: "Vocês fazem UI/UX Design?", 
            answer: "Sim! Criamos interfaces modernas e intuitivas, garantindo uma experiência de usuário fluida e otimizada para conversão." 
        },
        { 
            id: 15, 
            question: "O software passa por testes de qualidade?", 
            answer: "Sim! Contamos com uma equipe de QA (Quality Assurance) que realiza testes funcionais e automatizados para garantir a estabilidade do sistema." 
        },
    ],
    Notas: [
        { 
            id: 16, 
            question: "Vocês oferecem suporte técnico após a entrega?", 
            answer: "Sim! Temos planos de suporte 24h para garantir que seu sistema funcione sem interrupções." 
        },
        { 
            id: 17, 
            question: "O que está incluído nos contratos de manutenção?", 
            answer: "Os contratos incluem correções de bugs, atualizações de segurança e melhorias contínuas no sistema." 
        },
        { 
            id: 18, 
            question: "E se eu precisar de novas funcionalidades?", 
            answer: "Podemos desenvolver novas funcionalidades conforme sua demanda, garantindo que seu software evolua junto com seu negócio." 
        },
    ],
};